<div class="page">
  <div class="header">
    <h1 class="header-title">
      @if (returnTo()) {
        <button class="schedule-back" mat-icon-button aria-label="Terug" (click)="goBack()" style="color: inherit">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <mat-icon>person</mat-icon>
      <span>{{ userId() === dataStore.rootUser.id ? 'Mijn rooster' : 'Rooster' }}</span>
    </h1>
  </div>
  @if (userId()) {
    <div class="content" [class.loading-active]="isLoading()" [attr.aria-busy]="isLoading()">
      @if (isLoading()) {
        <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
          <mat-spinner [diameter]="42"></mat-spinner>
        </div>
      } @else {
        <div class="sub-header" [class.user-selection-active]="canSwitchType()" #subHeader>
          <div class="sub-header-left">
            <div class="user-selection">
              @if (currentUser()?.roles?.includes(RoleEnum.Driver)) {
                <button
                  class="account-type-button"
                  [class.type-selected]="this.selectedType() === RoleEnum.Driver"
                  [class.type-locked]="!canSwitchType()"
                  mat-icon-button
                  aria-label="Wissel naar chauffeurrooster"
                  matTooltip="Chauffeur"
                  [disableRipple]="!canSwitchType()"
                  [attr.aria-disabled]="!canSwitchType()"
                  (click)="canSwitchType() && changeType(RoleEnum.Driver)"
                >
                  <mat-icon>local_taxi</mat-icon>
                </button>
              }
              @if (dataStore.generalSettings.coDriverEnabled && currentUser()?.roles?.includes(RoleEnum.CoDriver)) {
                <button
                  class="account-type-button"
                  [class.type-selected]="this.selectedType() === RoleEnum.CoDriver"
                  [class.type-locked]="!canSwitchType()"
                  mat-icon-button
                  aria-label="Wissel naar bijrijderrooster"
                  matTooltip="Bijrijder"
                  [disableRipple]="!canSwitchType()"
                  [attr.aria-disabled]="!canSwitchType()"
                  (click)="canSwitchType() && changeType(RoleEnum.CoDriver)"
                >
                  <mat-icon>airline_seat_recline_normal</mat-icon>
                </button>
              }
              @if (
                currentUser()?.roles?.includes(RoleEnum.Planner) || currentUser()?.roles?.includes(RoleEnum.RidePlanner)
              ) {
                <button
                  class="account-type-button"
                  [class.type-selected]="this.selectedType() === RoleEnum.Planner"
                  [class.type-locked]="!canSwitchType()"
                  mat-icon-button
                  aria-label="Wissel naar plannerrooster"
                  matTooltip="Planner"
                  [disableRipple]="!canSwitchType()"
                  [attr.aria-disabled]="!canSwitchType()"
                  (click)="canSwitchType() && changeType(RoleEnum.Planner)"
                >
                  <mat-icon>today</mat-icon>
                </button>
              }
            </div>
            <div class="user-details">
              <p class="user-name">
                {{ name() }}
              </p>
              @if (currentUser()) {
                <p class="user-email">
                  <b>E-mailadres: </b>
                  <a href="mailto:{{ currentUser()?.email }}">{{ currentUser()?.email }}</a>
                </p>
                @if (currentUser()?.phone) {
                  <p class="user-phone">
                    <b>Telefoonnummer: </b>
                    <a href="tel:{{ currentUser()?.phone }}">{{ currentUser()?.phone }}</a>
                  </p>
                }
              }
            </div>
          </div>
        </div>
        <mat-tab-group animationDuration="500ms" mat-stretch-tabs #tabGroup>
          <mat-tab label="Planning">
            <app-planning [getUserId]="userId()!" [type]="selectedType()"></app-planning>
          </mat-tab>
          <mat-tab label="Beschikbaarheid">
            <app-availability
              [getUserId]="userId()!"
              [userCanModify]="userCanModify()"
              [type]="selectedType()"
            ></app-availability>
          </mat-tab>
          <mat-tab label="Uitzonderingen">
            <app-exceptions [getUserId]="userId()!" [userCanModify]="userCanModify()"></app-exceptions>
          </mat-tab>
          @if (this.selectedType() !== RoleEnum.Planner) {
            <mat-tab label="Voertuigen">
              <app-availability-vehicles
                [getUserId]="userId()!"
                [userCanModify]="userCanModify()"
                [type]="selectedType()"
              >
              </app-availability-vehicles>
            </mat-tab>
          }
        </mat-tab-group>
      }
    </div>
  }
</div>
